import React from 'react';
import {Stack, StackProps} from 'components/ui/chakra';

interface FormActionsProps extends StackProps {
	children: React.ReactNode;
}

const FormActions = ({children, ...rest}: FormActionsProps) => (
	<Stack
		align={{base: 'stretch', md: 'center'}}
		direction={{base: 'column-reverse', md: 'row'}}
		gap={3}
		justify='flex-end'
		mt={rest.mt ?? 6}
		pt={rest.pt ?? 2}
		{...rest}
	>
		{children}
	</Stack>
);

export default FormActions;
